import { gql } from '@grandvisionhq/graphql';
import { productFragment } from './product.js';

const lineItemsFragment = gql`
  fragment ReturnsLineItemsFragment on SlimOrderLineItem {
    quantity
    lineItemNumber
    product {
      ...ReturnProductFragment
    }
  }
  ${productFragment}
`;

export { lineItemsFragment };
//# sourceMappingURL=line-item.js.map
